export const fields = {
  cpf: {
    type: "cpf",
    name: "cpf",
    label: "CPF",
    sendFormat: "cpf",
    fetchFormat: "cpf"
  },
  name: {
    type: "name",
    name: "proponent_name",
    label: "nome completo",
    sendFormat: "text"
  },
  email: {
    type: "email",
    name: "proponent_email",
    label: "e-mail",
    rules: {
      domainMultipleChar: true
    }
  },
  phone: {
    type: "cellphone",
    name: "proponent_phone",
    label: "celular",
    sendFormat: "phone",
    fetchFormat: "phone",
    ariaLabel: "celular com ddd"
  },
  accountHolder: {
    type: "checkbox",
    name: "account_holder",
    label: "Já tenho uma conta no Itaú"
  }
}
